const getConstants = require('../../../utils/getConstants');
const isInactiveBySkippedRepeaterAncestor = require('./isInactiveBySkippedRepeaterAncestor');
const RuleEvaluator = require('./RuleEvaluator');
const entryTypeLookup = require('../entryTypeLookup');

const constants = getConstants();
const { answerStates, formItemTypes } = constants;

const containerTypes = new Set([formItemTypes.SECTION.id, formItemTypes.REPEATER_GROUP.id, formItemTypes.REPEATER.id]);
const normalizeId = (id) => (id == null ? null : id.toString().toLowerCase());
const isSkipped = (item) => !!item && (item.state & answerStates.SKIPPED) === answerStates.SKIPPED;

function buildChildrenByParent(items) {
   const childrenByParent = new Map();

   for (const item of Array.isArray(items) ? items : []) {
      const parentId = normalizeId(item.idParent);
      if (!childrenByParent.has(parentId)) {
         childrenByParent.set(parentId, []);
      }
      childrenByParent.get(parentId).push(item);
   }

   return childrenByParent;
}

function buildComponentByItemId(componentData) {
   const componentByItemId = new Map();
   const stack = componentData ? [componentData] : [];

   while (stack.length > 0) {
      const current = stack.pop();
      if (!current) continue;

      if (current.idItem != null) {
         componentByItemId.set(normalizeId(current.idItem), current);
      }

      const viewport = Array.isArray(current.viewport) ? current.viewport : [];
      for (let i = viewport.length - 1; i >= 0; i--) {
         stack.push(viewport[i]);
      }
   }

   return componentByItemId;
}

function deriveCanonicalLeafFailure({ current, items, componentByItemId, ruleEvaluator }) {
   const componentData = componentByItemId.get(normalizeId(current.id));
   if (!componentData || !componentData.componentType) {
      return current.failed === true;
   }

   const EntryType = entryTypeLookup[componentData.componentType];
   if (!EntryType) {
      return current.failed === true;
   }

   const aggregateRoot = { getResolver: () => null };
   const entry = new EntryType(aggregateRoot, componentData, items, [], ruleEvaluator);
   return entry.hasFailures();
}

function deriveFormItemResultMetadata({ item, items, componentData }) {
   if (!item || isSkipped(item) || isInactiveBySkippedRepeaterAncestor(items, item.id)) {
      return { flagged: false, noOfFlags: 0, failed: false };
   }

   const childrenByParent = buildChildrenByParent(items);
   const componentByItemId = buildComponentByItemId(componentData);
   const ruleEvaluator = new RuleEvaluator();

   const visit = (current) => {
      if (!current || isSkipped(current) || isInactiveBySkippedRepeaterAncestor(items, current.id)) {
         return { flagged: false, noOfFlags: 0, failed: false };
      }

      if (!containerTypes.has(current.idItemType)) {
         const noOfFlags = Number(current.noOfFlags) || (current.flagged ? 1 : 0);
         return {
            flagged: noOfFlags > 0 || current.flagged === true,
            noOfFlags,
            failed: deriveCanonicalLeafFailure({ current, items, componentByItemId, ruleEvaluator })
         };
      }

      let flagged = false;
      let noOfFlags = 0;
      let failed = false;
      const children = childrenByParent.get(normalizeId(current.id)) || [];

      for (const child of children) {
         const childResult = visit(child);
         if (childResult.flagged) {
            flagged = true;
            noOfFlags += childResult.noOfFlags || 1;
         }
         if (childResult.failed) {
            failed = true;
         }
      }

      return { flagged, noOfFlags, failed };
   };

   return visit(item);
}

module.exports = {
   deriveFormItemResultMetadata
};
